/* eslint lodash/prefer-noop: [0] */
// should not be any imports here, since they might have `console.*` calls

if (!window.console) {
  const methods = [
    'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
    'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
    'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
    'timeStamp', 'trace', 'warn',
  ];
  const noop = () => {};
  window.console = () => methods.reduce((result, method) => ({...result, [method]: noop}), {});
}



// WEBPACK FOOTER //
// ./src/misc/fakeConsole.js